import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import "./ChatBot.scss";
export default function ChatBot({ auth_token, expires_at ,user}) {
  const [messages, setMessages] = useState([{
            message:  `Hi ${user?.name},\nHow can I help you today?`,
            sender: "bot",
            direction: "incoming",
          }]);
  const [isTyping, setIsTyping] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [token, setToken] = useState(auth_token);
  const [expiresAt, setExpiresAt] = useState(expires_at);
  const [visible, setVisible] = useState(true);

  const handleClose = () => setVisible(false);

  const handleSend = (userInput) => {
    const userMessage = {
      message: userInput,
      sender: "user",
      direction: "outgoing",
    };
    setMessages((prev) => [...prev, userMessage]);
    setIsTyping(true);

    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");

    axios
      .post(
        "/v2/chat_bot",
        {
          question: userInput,
          token: token,
          chat_history: chatHistory,
          base_url: window.location?.origin,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
        }
      )
      .then((res) => {
        const data = res.data;
        setMessages((prev) => [
          ...prev,
          {
            message: data.response,
            sender: "bot",
            direction: "incoming",
          },
        ]);
        setChatHistory((prev) => [
          ...prev,
          {
            inputs: { question: userInput },
            outputs: { answer: data.response },
          },
        ]);
      })
      .catch(() => {
        setMessages((prev) => [
          ...prev,
          {
            message: "Sorry, something went wrong.",
            sender: "bot",
            direction: "incoming",
          },
        ]);
      })
      .finally(() => setIsTyping(false));
  };

  useEffect(() => {
    const now = Date.now();
    const expiryTs =
      typeof expiresAt === "number"
      ? expiresAt
        : new Date(expiresAt).getTime();
    const delay = Math.max(expiryTs - now, 0);
    const timer = setTimeout(() => {
      axios
        .get("/v2/chat_bot", {
          headers: { Accept: "application/json" },
      })
        .then((response) => {
          const { token, expires_at } = response.data;
          setToken(token);
          setExpiresAt(expires_at);
        })
        .catch((error) => {
          console.error("Failed to fetch token", error);
      });
    }, delay);
    return () => clearTimeout(timer);
  }, [expiresAt]);

  if (!visible) return null;
 
  return (
    <div className="chat-modal-overlay">
      <div className="chat-modal">
        <div className="chat-modal-header">
          AI Assist
          <button className="chat-close-btn" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="chat-modal-content">
          <MainContainer>
            <ChatContainer>
              <MessageList
                typingIndicator={
                  isTyping ? (
                    <TypingIndicator content="Bot is typing..." />
                  ) : null
                }
              >
                {messages.map((msg, i) => (
                  <Message
                    key={i}
                    model={{
                      message: msg.message,
                      sentTime: "just now",
                      sender: msg.sender,
                      direction: msg.direction,
                    }}
                  />
                ))}
              </MessageList>
            </ChatContainer>
          </MainContainer>
        </div>
        <div className="chat-modal-footer">
          <MessageInput
            attachButton={null}
            placeholder="Ask me anything..."
            onSend={handleSend}
          />
    </div>
      </div>
    </div>
  );
}
